import { ChangeEventHandler, FC, useCallback, useState } from 'react'
import PageLayout from '../../../components/page-layout/page-layout'
import { Anchor, Col, ConfigProvider, Input, Row, Table, theme } from 'antd'
import { columns } from './constants/columns'
import Title from 'antd/es/typography/Title'
import { AnchorContainer } from 'antd/lib/anchor/Anchor'
import { useGetStockBalancesQuery } from '../../../store/api/stocks-api'

interface MaterialsPageProps {}

const MaterialsPage: FC<MaterialsPageProps> = () => {
    const { data } = useGetStockBalancesQuery()
    const [searchValue, setSearchValue] = useState<string>('')
    const materialGroups = data?.data || []

    const onSearch: ChangeEventHandler<HTMLInputElement> = useCallback(e => {
        setSearchValue(e.target.value)
    }, [])

    return (
        <PageLayout title={'Остаток материала'} scrollableContent>
            <Row gutter={48}>
                <Col sm={20}>
                    <Input.Search
                        style={{ width: 400 }}
                        placeholder={'Поиск по наименованию'}
                        value={searchValue}
                        onChange={onSearch}
                    />
                </Col>
                <Col sm={20}>
                    <ConfigProvider theme={{ algorithm: theme.compactAlgorithm }}>
                        {materialGroups.map(materialGroup => {
                            const materialTypes = materialGroup.material_types?.filter(x =>
                                x.name.toLowerCase().includes(searchValue.toLowerCase())
                            )

                            if (!materialTypes?.length) return null

                            return (
                                <Table
                                    columns={columns}
                                    dataSource={materialTypes}
                                    title={() => (
                                        <Title level={3} id={materialGroup.id.toString()}>
                                            {materialGroup.name}
                                        </Title>
                                    )}
                                    bordered={false}
                                    showHeader={false}
                                    pagination={false}
                                    key={materialGroup.documentId}
                                    rowKey={x => x.documentId}
                                    scroll={{ x: 'max-content' }}
                                />
                            )
                        })}
                    </ConfigProvider>
                </Col>
                <Col span={4}>
                    <Anchor
                        affix
                        offsetTop={24}
                        getContainer={() =>
                            document.getElementById('page-layout__content') as AnchorContainer
                        }
                        items={materialGroups.map(group => ({
                            key: group.id,
                            href: `#${group.id}`,
                            title: group.name,
                        }))}
                    />
                </Col>
            </Row>
        </PageLayout>
    )
}

export default MaterialsPage
